export enum StatusChangeType {
  DELAY = "DELAY",
  CANCEL = "CANCEL",
  SOLD_OUT = "SOLD_OUT",
}
